<template>
    <div class="ps-page-body">
        <SeoHead title="Services" description="Services offered with ProfileSuite for cards, pages, and lead capture." />

        <marketing-page-hero
            eyebrow="What we offer"
            :title="__('Our Services')"
            :lead="__('Print cards, digital presence, and lead tools — packaged for agencies and businesses.')"
        />

        <!-- Start Section-->
        <section class="relative md:py-24 py-16">
            <div class="container">
                <div class="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-[30px]">
                    <div v-for="(service, si) in page.services" :key="si" class="p-6 transition duration-500 rounded-2xl mt-6 text-center" v-bind:class="{'shadow-xl shadow-gray-100 dark:shadow-gray-800':si%2===0,'hover:shadow-xl hover:shadow-gray-100 dark:hover:shadow-gray-800':si%2!==0}">
                        <div class="w-20 h-20 bg-indigo-600/5 text-indigo-600 rounded-xl text-3xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 mx-auto">
                            <icon class="w-8 w-8 fill-indigo-600" :name="service.icon" />
                        </div>

                        <div class="content mt-7">
                            <h2 class="title h5 text-lg font-medium hover:text-indigo-600">{{ service.name }}</h2>
                            <p class="text-slate-400 mt-3" v-html="sanitizeHtml(service.details)"></p>
                        </div>
                    </div>
                </div><!--end grid-->
            </div><!--end container-->


            <div class="container md:mt-24 mt-16">
                <div class="grid grid-cols-1 text-center">
                    <h6 class="text-indigo-600 text-sm font-bold mb-2">{{ page.contact.tag }}</h6>
                    <h3 class="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold" v-html="sanitizeHtml(page.contact.title)"></h3>

                    <p class="text-slate-400 max-w-xl mx-auto" v-html="sanitizeHtml(page.contact.details)"></p>

                    <div class="mt-6">
                        <a :href="route('contact')" class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md mr-2 mt-2"><i class="uil uil-phone"></i> Contact Us</a>
                    </div>
                </div><!--end grid-->
            </div><!--end container-->
        </section><!--end section-->
        <!-- End Section-->
    </div>
</template>
<script>
import Layout from '@/Shared/Landing/Layout'
import Icon from '@/Shared/Icon'
import MarketingPageHero from '@/Shared/Landing/MarketingPageHero'
import SeoHead from '@/Shared/SeoHead'
import sanitizeHtml from 'sanitize-html'

export default {
    layout: Layout,
    props: {
        data: Object,
    },
    components: {
        Icon,
        MarketingPageHero,
        SeoHead,
    },
    data() {
        return {
            page: JSON.parse(this.data.html)
        }
    },
    methods: {
        sanitizeHtml : sanitizeHtml
    }
}
</script>
